import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  input,
  Output,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import {
  FiltersLocation,
  FiltersRegion,
} from '../../interfaces/region.interface';
import { LocationsFilterPipe } from './locationsFilter.pipe';
import { CssVarToNumberPipe } from '@shared/pipes/css-var-to-number.pipe';

@Component({
  selector: 'z-bc-top-header-filters',
  standalone: true,
  imports: [
    CommonModule,
    MultiSelectModule,
    FormsModule,
    LocationsFilterPipe,
    CssVarToNumberPipe,
  ],
  templateUrl: './bc-top-header-filters.component.html',
  styleUrls: ['./bc-top-header-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BCTopHeaderFiltersComponent {
  regions = input.required<FiltersRegion[]>();
  locations = input.required<FiltersLocation[]>();

  locationsFilters = output<FiltersLocation[]>();

  locationsActive = signal<'locations' | null>(null);
  regionsActive = signal<'regions' | null>(null);

  @Input({ required: true }) selectedRegions: FiltersRegion[] = [];
  @Output() selectedRegionsChange = new EventEmitter<FiltersRegion[]>();

  @Input({ required: true }) selectedLocations: FiltersLocation[] = [];
  @Output() selectedLocationsChange = new EventEmitter<FiltersRegion[]>();

  constructor(readonly cd: ChangeDetectorRef) {}

  openFilters(multiSelect: MultiSelect) {
    if (multiSelect.overlayViewChild) {
      multiSelect.overlayViewChild.styleClass =
        'multiselect-overlay-filter-position';
    }
    multiSelect.show();
  }

  onRegionChange() {
    this.selectedLocations = this.selectedLocations.filter(l =>
      this.selectedRegions.some(r => r.id === l.regionId),
    );
    this.selectedLocationsChange.emit(this.selectedLocations);
    this.locationsFilters.emit(this.selectedLocations);
    this.cd.detectChanges();
  }

  onLocationChange() {
    this.locationsFilters.emit(this.selectedLocations);
    this.cd.detectChanges();
  }

  regionsChange(ev: any) {
    this.selectedRegionsChange.emit(ev);
    this.cd.detectChanges();
  }

  locationsChange(ev: any) {
    this.selectedLocationsChange.emit(ev);
    this.cd.detectChanges();
  }
}
